import { render, staticRenderFns } from "./TodoView.vue?vue&type=template&id=2a380558&scoped=true&"
import script from "./TodoView.vue?vue&type=script&lang=js&"
export * from "./TodoView.vue?vue&type=script&lang=js&"
import style0 from "./TodoView.vue?vue&type=style&index=0&id=2a380558&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a380558",
  null
  
)

export default component.exports